import { render, staticRenderFns } from "./block-ui.vue?vue&type=template&id=390609fe&scoped=true&"
import script from "./block-ui.vue?vue&type=script&lang=js&"
export * from "./block-ui.vue?vue&type=script&lang=js&"
import style0 from "./block-ui.vue?vue&type=style&index=0&id=390609fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390609fe",
  null
  
)

export default component.exports